import React from "react";
import { Link } from "react-router-dom";

export default function ContactSalesCTA() {
  return (
    <section
      aria-label="Contact Sales"
      className="w-full bg-black text-white font-display"
    >
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-[1.4fr_1fr] gap-10 items-center">
        <div>
          <span className="inline-block text-xs uppercase tracking-[0.25em] text-white/60 font-semibold mb-4">
            Custom-priced for what you actually run
          </span>
          <h2 className="text-3xl sm:text-4xl font-medium leading-tight mb-4 font-display">
            Talk to sales. Get a number on the same call.
          </h2>
          <p className="text-white/70 leading-relaxed max-w-2xl">
            Real-time livestream censoring, multimodal moderation at platform
            scale, our static image API, and every solution on this site is
            quoted to your volume and use case. Tell us what you need to
            detect — we'll come back with a plan, an SLA, and pricing.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <Link
            to="/contact-sales"
            className="inline-flex items-center justify-center bg-white text-black font-semibold px-7 py-3 rounded-full hover:bg-neutral-200 transition"
          >
            Contact Sales
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center bg-transparent border border-white/40 text-white font-semibold px-7 py-3 rounded-full hover:bg-white/10 transition"
          >
            See self-serve plans
          </Link>
        </div>
      </div>
    </section>
  );
}
